export const SET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION =
    'SET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION';
export const REMOVE_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION =
    'REMOVE_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION';
export const RESET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION =
    'RESET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION';
